/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import ReactHtmlParser from "react-html-parser";
import { attemptsLeftText } from "../../utils/constants";
import VideoPopup from "../VideoPopup";

const QuestionDetails = ({
  attempts,
  question,
  omt,
  omt_iframes,
  lessonLink,
  lesson_links_iframes,
}) => {
  return (
    <>
      <div className="question">{ReactHtmlParser(question || "<p>NA</p>")}</div>
      <div className="question_details">
        <div className="question_attempt">
          {attempts} {attemptsLeftText}
        </div>
        <div className="question_mix">
          
          {/* {lessonLink && lessonLink.length
            ? lessonLink.map((link: { url: string; title: string }) => (
                <div key={link.title} className="question_tutorials">
                  <a href={link.url} target="_blank">
                    {link.title}
                  </a>
                </div>
              ))
            : null} */}

          {lesson_links_iframes.length > 1 ? (
            <>
              <VideoPopup
                video_links={lesson_links_iframes}
                popup_btn_text="Lesson Links"
              />
            </>
          ) : null}

          {omt && !omt_iframes ? (
            <>
              <div className="question_tutorials">
                <a href={omt.link} target="_blank">
                  {omt.text}
                </a>
              </div>
            </>
          ) : null}
          {omt_iframes ? (
            <>
              <VideoPopup
                video_links={omt_iframes}
                popup_btn_text="One Minute Tutorial"
              />
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default QuestionDetails;
